import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const LoaderInit = {
  show: false,
  showLoader: null,
};

export const LoaderContext = createContext(LoaderInit);

const LoaderContextProvider = ({ children }) => {
  const [show, showLoader] = useState(false);
  const value = useMemo(() => ({ show, showLoader }), [show]);
  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
};

LoaderContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoaderContextProvider;
